import { getActiveDirectors, getActiveSecretaries } from '../../sgDocGenEntityApi';
import { dedupePresetSigners } from '../../presetSignerDedup';

function trim(v: unknown): string {
  return v === null || v === undefined ? '' : String(v).trim();
}

function toSignerJson(
  items: Array<{ name: string; email?: string; role?: string; contactCd?: string; contactRegNo?: string }>,
): string {
  const list = dedupePresetSigners(items);
  return list.length > 0 ? JSON.stringify(list) : '';
}

/** Directors + company secretaries for [[Signers]] on Share Certificate (PRS014). */
export async function buildShareCertificateSignersJson(entityCd: string): Promise<string> {
  if (!trim(entityCd)) return '';
  const items: Array<{ name: string; email?: string; role?: string; contactCd?: string; contactRegNo?: string }> = [];

  try {
    const dirRes: any = await getActiveDirectors(entityCd);
    for (const d of dirRes?.data?.directors || []) {
      const name = trim(d?.name || d?.contactName);
      if (!name) continue;
      items.push({
        name,
        email: trim(d?.contactEmail || d?.email),
        contactCd: trim(d?.contactCd || d?.CONTACT_CD),
        contactRegNo: trim(d?.contactRegNo || d?.CONTACT_REG_NO || d?.contactIdUen),
        role: 'director',
      });
    }
  } catch (e) {
    console.warn('[shareCertificateSigners] getDirectors failed:', e);
  }

  try {
    const secRes: any = await getActiveSecretaries(entityCd);
    for (const s of secRes?.data?.secretaries || []) {
      const name = trim(s?.name || s?.contactName);
      if (!name) continue;
      items.push({
        name,
        email: trim(s?.contactEmail || s?.email),
        contactCd: trim(s?.contactCd || s?.CONTACT_CD),
        contactRegNo: trim(s?.contactRegNo || s?.CONTACT_REG_NO || s?.contactIdUen),
        role: 'secretary',
      });
    }
  } catch (e) {
    console.warn('[shareCertificateSigners] getSecretaries failed:', e);
  }

  return toSignerJson(items);
}
